<template>
    <default-modal
        :show="showModal"
        :height="0"
        :closeOnClickModal="false"
        @close="closeModal"
    >
        <ns-loader
            v-if="channel !== null"
            ref="nsLoader"
            :to-load="toLoad"
            :fetch-timer="null"
            @dataFetched="onDataFetched"
        >
            <loading-template slot="loader"></loading-template>
            <el-form
                slot="content"
                ref="form"
                :model="form"
                :rules="rules"
                class="modal-confirm-channel"
            >
                <div 
                    v-if="editingTimeFields"
                    style="color: white; margin-bottom:1rem;"
                >
                    Editing Default start/Default end times won't apply to running<br> programmation.
                    Your change will be effective when the next<br> programmation start.
                </div>
                <div 
                    v-if="editingOtherFields || confirmation"
                    class="gcmcn-inputs-container"
                >
                    <div class="flex-basis-5">
                        <el-form-item class="gcmcn-form-input" prop="multicast_network_ip_main">
                            <div class="gcmcn-form-label">Main multicast ip</div>
                            <el-input
                                v-model="form.multicast_network_ip_main"
                                size="mini"
                            >
                            </el-input>
                        </el-form-item>
                    </div>
                    <div class="flex-basis-5">
                        <el-form-item class="gcmcn-form-input" prop="multicast_network_ip_backup">
                            <div class="gcmcn-form-label">Backup multicast ip</div>
                            <el-input
                                v-model="form.multicast_network_ip_backup"
                                size="mini"
                            >
                            </el-input>
                        </el-form-item>
                    </div>
                    <div class="flex-basis-5">
                        <el-form-item class="gcmcn-form-input" prop="multicast_network_src_main">
                            <div class="gcmcn-form-label">Main source ip</div>
                            <el-input
                                v-model="form.multicast_network_src_main"
                                size="mini"
                            >
                            </el-input>
                        </el-form-item>
                    </div>
                    <div class="flex-basis-5">
                        <el-form-item class="gcmcn-form-input" prop="multicast_network_src_backup">
                            <div class="gcmcn-form-label">Backup source ip</div>
                            <el-input
                                v-model="form.multicast_network_src_backup"
                                size="mini"
                            >
                            </el-input>
                        </el-form-item>
                    </div>
                    <div class="flex-basis-5">
                        <el-form-item class="gcmcn-form-input" prop="port_main">
                            <div class="gcmcn-form-label">Main port</div>
                            <el-input
                                v-model.number="form.port_main"
                                size="mini"
                            >
                            </el-input>
                        </el-form-item>
                    </div>
                    <div class="flex-basis-5">
                        <el-form-item class="gcmcn-form-input" prop="port_backup">
                            <div class="gcmcn-form-label">Backup port</div>
                            <el-input
                                v-model.number="form.port_backup"
                                size="mini"
                            >
                            </el-input>
                        </el-form-item>
                    </div>
                </div>
                <div 
                    v-if="editingOtherFields || confirmation"
                    class="gcmcn-inputs-container"
                >
                    <div class="flex-basis-10">
                        <el-form-item class="gcmcn-form-input" prop="type">

                            <div class="gcmcn-form-label type-input-spacing">Type</div>
                            <el-select v-model="form.type" placeholder="RTP" class="gcmcn-form-label">
                                <div class="gcmcn-form-label options-type"></div>
                                <el-option 
                                    v-for="item in options"
                                    :key="item.type"
                                    :label="item.label"
                                    :value="item.type"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </div>

                <div
                    v-if="(userIsAtLeastAdmin || userIsEntityAdmin(entityUid)) && !editingTimeFields"
                    class="gcmcn-inputs-container"
                >
                    <div class="flex-basis-10">
                        <el-form-item class="gcmcn-form-input" prop="datacenter_obj_uid">
                            <div class="gcmcn-form-label type-input-spacing">Globecast Region</div>
                            <el-select
                                v-model="form.datacenter_obj_uid"
                                class="gcmcn-form-label"
                                :disabled="editingOtherFields"
                            >
                                <el-option
                                    v-for="datacenter in datacenters"
                                    :key="datacenter.uid"
                                    :label="datacenter.name"
                                    :value="datacenter.uid"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </div>


                <div 
                    v-if="editingTimeFields"
                    class="gcmcn-inputs-container"
                >
                    <div>
                        <el-form-item class="gcmcn-form-input" prop="default_start_time">
                            <div class="gcmcn-form-label">From</div>
                            <ns-time-picker
                                v-model="form.default_start_time"
                                :display-seconds="false"
                                :display-digital-clock="true"
                            ></ns-time-picker>
                        </el-form-item>
                    </div>
                </div>
                <div 
                    v-if="editingTimeFields"
                    class="gcmcn-inputs-container"
                >
                    <div>
                        <el-form-item class="gcmcn-form-input" prop="default_end_time">
                            <div class="gcmcn-form-label">To</div>
                            <ns-time-picker
                                v-model="form.default_end_time"
                                :display-seconds="false"
                                :display-digital-clock="true"
                            ></ns-time-picker>
                        </el-form-item>
                    </div>
                </div>
                <el-alert
                    type="warning"
                    effect="dark"
                    :closable="false"
                >
                    <p style="font-weight: bolder; word-break: break-word">Do you really want to confirm this channel ?<br>
                    Please check carefully the data provided and confirm the action by typing "CONFIRM"</p>
                    <el-form-item class="gcmcn-form-input" style="margin-top: 15px;" prop="passPhrase">
                        <el-input v-model="form.passPhrase" placeholder="Enter confirm"></el-input>
                    </el-form-item>
                </el-alert>
            </el-form>
        </ns-loader>
        <div class="modal-action-button-container">
            <el-button
                class="delete-event-cancel-btn"
                type="text"
                small
                :loading="loading"
                @click="closeModal"
            >Cancel</el-button>
            <el-button
                class="gcmcn-primary-btn small validate-btn delete-event-confirm-btn"
                :loading="loading"
                @click="confirmation?confirmChannel():confirmModificationRequest()"
            >Validate</el-button>
        </div>
    </default-modal>

</template>

<script>
import moment from 'moment';
import DefaultModal from 'gcmcn-common/src/components/gcmcn-modal-theme.vue';
import NsTimePicker from 'fundation-app-vuejs/src/components/partials/ns-time-picker.vue';
import NsLoader from 'fundation-app-vuejs/src/components/partials/ns-vue-loader';
import LoadingTemplate from '../../partials/ns-loader-template.vue';
import { mapGetters } from 'vuex';
export default {

    components: {
        DefaultModal,
        NsTimePicker,
        NsLoader,
        LoadingTemplate,
    },

    props: {

    },

    data (){
        return {
            showModal: false,
            form: {
                multicast_network_ip_main: '',
                multicast_network_src_main: '',
                multicast_network_ip_backup: '',
                multicast_network_src_backup: '',
                datacenter_obj_uid: '',
                port_main: 0,
                port_backup: 0,
                default_start_time: '',
                default_end_time: '',
                passPhrase: '',
                type: 'RTP',
            },
            options: [{
                type: 'UDP',
                label: 'UDP'
            },
            {
                type: 'RTP',
                label: 'RTP'
            }],
            loading: false,
            channel: null,
            event: null,
            videoSource: null,
            confirmation: false,
            editingTimeFields: false,
            editingOtherFields: false,
            durationParameter: 0,
            datacenters: []
        };
    },

    computed: {
        ...mapGetters([
            'userIsAtLeastAdmin',
            'userIsEntityAdmin',
            'entitiesByUid',
            'groups'
        ]),
        toLoad (){
            let parametersToFetch = [
                {
                    model: 'parameters',
                    name: 'durationParameter',
                    filters:{
                        name: 'MIN_CHANNEL_DURATION_IN_MIN',
                    }
                },
                {
                    model: 'datacenters',
                    name: 'datacenters',
                    filters:{
                        archived: false,
                    }
                },
            ];
            if(this.channel && this.channel.confirmed){
                return [
                    {
                        model: 'videoSources',
                        name: 'videoSource',
                        uid: this.channel.video_source_uid,
                    },
                    ...parametersToFetch
                ];
            } 
            return parametersToFetch;
    
        },
        rules (){
            let rules = {
                default_start_time: [{validator: this.validStartTime, required: true}],
                default_end_time: [{validator: this.validEndTime, required: true}],
                passPhrase: [{ validator: this.checkConfirm, required: true}],
                type: [{ type: 'string', required: true}],
                multicast_network_ip_main: [{validator: this.checkIp, required: true}],
                multicast_network_src_main: [{validator: this.checkIp, required: true}],
                multicast_network_ip_backup: [{validator: this.checkIp, required: true}],
                multicast_network_src_backup: [{validator: this.checkIp, required: true}],
                port_main: [{type: 'number', required: true}],
                port_backup: [{type: 'number', required: true}],
            };

            return rules;
        },
        createModificationRequest(){
            if(!this.confirmation){
                return true;
            }
            return false;
        },
        entityUid(){
            if(this.channel){
                return this.channel.scopes.entity_uid;
            }
            return null;
        }
    },

    mounted (){
    },

    methods: {

        checkIp (rule, value, callback) {
            if(!value){
                return callback(new Error('This field can\'t be empty'));
            }else if(!value.match(this.$store.getters.regexIp)){
                return callback(new Error('This field must be a valid ip'));
            }
            callback();
        },
        validStartTime (rule, value, callback) {
            if(!this.form.default_start_time){
                return callback(new Error('Start time is required'));
            }else if(!this.form.default_start_time.match(/^([0-1][0-9]|2[0-3]|[0-9])\:([0-5][0-9]|[1-9])$/gm)){
                return callback(new Error('Start time format must match HH:mm pattern'));
            }else{
                callback();
            }
        },
        validEndTime (rule, value, callback) {
            if(!this.form.default_end_time){
                return callback(new Error('End time is required'));
            }else if(!this.form.default_end_time.match(/^([0-1][0-9]|2[0-3]|[0-9])\:([0-5][0-9]|[1-9])$/gm)){
                return callback(new Error('End time format must match HH:mm pattern'));
            }

            //check if end and start time are at least 30min apart,
            let start = moment(this.form.default_start_time, 'HH:mm');
            let end = moment(this.form.default_end_time, 'HH:mm');
            let duration = moment(end.diff(start)).subtract(1, 'hours').format('HH:mm');
            let minDurationInMinutes = moment(`00:${this.durationParameter}`, 'HH:mm').format('HH:mm');
            if( duration < minDurationInMinutes){
                return callback(new Error(`End time must  be at least ${this.durationParameter} min after start time`));
            }
            callback();
        },

        checkConfirm (rule, value, callback) {
            if(!value){
                return callback(new Error('Pass phrase is required'));
            }else if(value !== 'CONFIRM'){
                return callback(new Error('Pass phrase must be equal to CONFIRM in uppercase.'));
            }
            callback();
        },
        onDataFetched (res){
            this.$set(this, 'datacenters', res.datacenters);
            this.$set(this, 'durationParameter', res.durationParameter[0].data.value);
            if(res.videoSource){
                this.$set(this, 'videoSource', res.videoSource);

                this.form.multicast_network_ip_main = this.videoSource.multicast_network_ip_main;
                this.form.multicast_network_src_main = this.videoSource.multicast_network_src_main;
                this.form.multicast_network_ip_backup = this.videoSource.multicast_network_ip_backup;
                this.form.multicast_network_src_backup = this.videoSource.multicast_network_src_backup;
                this.form.datacenter_obj_uid = this.videoSource.datacenter_obj_uid;
                this.form.port_main = parseInt(this.videoSource.port_main);
                this.form.port_backup = parseInt(this.videoSource.port_backup);
                this.form.type = this.videoSource.type;
                this.form.default_start_time = moment.utc(this.channel.default_start_time, 'HH:mm').format('HH:mm');
                this.form.default_end_time = moment.utc(this.channel.default_end_time, 'HH:mm').format('HH:mm');
            } else {
                let datacenterDefaultValue = this.datacenters.find((datacenter) => datacenter.is_default === true);
                let datacenterEntityDefaultValue = this.entitiesByUid(this.channel.scopes.entity_uid).datacenter;

                if(datacenterEntityDefaultValue){
                    this.$set(this.form, 'datacenter_obj_uid', datacenterEntityDefaultValue);
                } else {
                    this.$set(this.form, 'datacenter_obj_uid', datacenterDefaultValue.uid);
                }
            }

        },
        open (channel, event){
            this.$set(this, 'channel', channel);
            this.$set(this, 'event', event);
            this.showModal = true;
        },
        closeModal (){
            this.showModal = false;
            this.form.default_end_time = '';
            this.form.default_start_time = '';
            this.$set(this, 'channel', null);
            this.$set(this, 'event', null);
            this.form.passPhrase = '';
            this.confirmation = false;
            this.editingTimeFields = false;
            this.editingOtherFields = false;

        },

        confirmChannel (){
            this.$refs.form.validate(async (valid) => {
                if(!valid) return;
                this.loading = true;
                let videoSourceResponse = null;
                let videoSource = Object.assign({}, this.form);
                let method = 'createItem';
                let data = {
                    item: videoSource,
                    model: 'videoSources',
                };
                if(this.videoSource){
                    data.item.url = this.videoSource.url;
                    method = 'patchItem';
                }else{
                    data.item.name = `${ this.event.name } - ${ this.channel.name }`;
                    data.scopes = {'X-Entity-Uid': this.entityUid};
                    data.url = this.$store.state.api.meta.listModels.videoSources.url;
                }
                videoSourceResponse = await this.$store.dispatch(method, data).catch((e) => {
                    console.error(e);
                    this.$notify({
                        type: 'error',
                        title: `Error on channel ${this.channel.display_name} confirmation`
                    });
                    this.loading = false;
                    return;
                });
                let item = {
                    confirmed: true,
                    url: this.channel.url,
                };
                item.video_source_uid = videoSourceResponse.uid;

                this.$store.dispatch('patchItem', {
                    item: item,
                    model: 'channels',
                }).then(() => {
                    this.$notify({
                        type: 'success',
                        title: `Channel ${this.channel.display_name} confirmed`
                    });
                    this.$emit('on-trigger-refresh');
                    this.closeModal();
                }).catch((e) => {
                    console.error(e);
                    this.$notify({
                        type: 'error',
                        title: `Error on channel ${this.channel.display_name} confirmation`
                    });
                }).finally(() => {
                    this.loading = false;
                });
            });
        },
        confirmModificationRequest (){
            this.$refs.form.validate(async (valid) => {
                if(!valid) return;

                this.loading = true;
                let item;
                let action;

                if(this.editingTimeFields){
                    item = {
                        default_start_time :moment.utc(this.form.default_start_time, 'HH:mm:ss').format('HH:mm:ss'),
                        default_end_time: moment.utc(this.form.default_end_time, 'HH:mm:ss').format('HH:mm:ss'),
                        url: this.channel.url,
                    };
                    this.$store.dispatch('patchItem',{
                        item: item,
                        model: 'channels'
                    }).then(()=>{
                        this.$message({
                            message: `Channel ${this.channel.display_name} start/end times successfully updated`,
                            type: 'success'
                        });
                        this.closeModal();
                        this.loading = false;
                        this.$emit('on-trigger-refresh');
                    }).catch(()=>{
                        this.$message.error(`Error on updating ${this.channel.display_name} start/end times`);
                        this.closeModal();
                        this.loading = false;
                    });
                }
                if(this.editingOtherFields){
                    action = 'UPDATE_INPUT';
                    let context = Object.assign({}, this.form);
                    let contextJSON = JSON.parse(JSON.stringify(context));
                    delete contextJSON ['passPhrase'];
                    delete contextJSON ['default_end_time'];
                    delete contextJSON ['default_start_time'];
                    delete contextJSON ['datacenter_obj_uid'];
                    item = {
                        context: contextJSON,
                        status: 'PENDING',
                        action: action,
                        channel_uid: this.channel.uid,
                    };
                    this.$store.dispatch('createItem', {
                        item: item,
                        model: 'channelModificationRequests',
                        url: this.$store.state.api.meta.listModels.channelModificationRequests.url

                    }).then((res) => {
                        this.$emit('watch-channel-modification-request', res.url);
                        this.closeModal();
                    }).finally(() => {
                        this.loading = false;
                    });
                }
            });
        },
    },
};
</script>

<style lang="scss">
.modal-confirm-channel{
    .el-input:not(.hours):not(.minutes):not(.seconds):not(.digital-clock){
        width: 100%;
    }
    .el-alert{
        .el-form-item__error{
            color: #ff1100;
        }
    }
    .options-type {
        padding-bottom: 0.5em;;
    }
}
.type-input-spacing{
    padding-bottom: 0.5em;
}
</style>


// WEBPACK FOOTER //
// src/components/page/Channels/modal-confirm-channel.vue